import React from 'react';
import { Grid, Box, Typography } from '@quillbot/design-system';

interface IProps {
  classes: Record<string, string>;
  /* classes: {
    affiliateTableData: string;
    commissionTableWrapper: string;
    affiliateTable: string;
    affiliateTableHeader: string;
    featureWrapper: string;
    featureHeader: string;
  }; */
}

function CommisionDetails(props: IProps) {
  const commissionData = [
    {
      plans: 'Monthly',
      commission: '10%',
    },
    {
      plans: 'Semi-Annual',
      commission: '15%',
    },
    {
      plans: 'Annual',
      commission: '20%',
    },
  ];

  const renderTableData = () =>
    commissionData.map((ele) => (
      <tr key={ele.plans}>
        <td className={props.classes.affiliateTableData}>{ele.plans}</td>
        <td className={props.classes.affiliateTableData}>{ele.commission}</td>
        {/* <td className={props.classes.affiliateTableData}>{ele.commission}</td> */}
        {/* <td className={props.classes.affiliateTableData}>{ele.payout}</td> */}
      </tr>
    ));

  return (
    <>
      <Grid item sm={12} xs={12} md={6}>
        <Box className={props.classes.commissionTableWrapper}>
          <table className={props.classes.affiliateTable}>
            <thead>
              <tr className={props.classes.affiliateTableHeader}>
                <th className={props.classes.affiliateTableHeaders}>Plans</th>
                <th className={props.classes.affiliateTableHeaders}>Percentage</th>
                {/* <th className={props.classes.affiliateTableHeaders}>
                Commission
              </th>
              <th className={props.classes.affiliateTableHeaders}>Payout</th> */}
              </tr>
            </thead>
            <tbody>{renderTableData()}</tbody>
          </table>
        </Box>
      </Grid>

      <Grid item sm={12} xs={12} md={6}>
        <Box className={props.classes.featureWrapper}>
          <div>
            <Typography variant="h4" className={props.classes.featureHeader}>
              Features
            </Typography>
            <Box style={{ padding: '0px 31px' }}>
              <li
                className={props.classes.featureList}
                style={{
                  listStyleImage: "url('/images/tick.svg')",
                }}
              >
                30-day cookie window
              </li>
              <li
                className={props.classes.featureList}
                style={{
                  listStyleImage: "url('/images/tick.svg')",
                }}
              >
                Cross-device tracking with a unique URL
              </li>
              <li
                className={props.classes.featureList}
                style={{
                  listStyleImage: "url('/images/tick.svg')",
                }}
              >
                Dashboard to monitor sales and earnings
              </li>
            </Box>
          </div>
        </Box>
      </Grid>
    </>
  );
}

export default CommisionDetails;
